import './Form.css';
import { useState } from 'react';
import categories from '../categories-list';
import supabase from '../supabase';
function isValidHttpUrl(string) {
	let url;
	try {
		url = new URL(string);
	} catch (_) {
		return false;
	}
	return url.protocol === 'http:' || url.protocol === 'https:';
}
function Form({ setQuotes, setShowForm }) {
	const [text, setText] = useState('');
	const [author, setAuthor] = useState('');
	const [source, setSource] = useState('');
	const [category, setCategory] = useState('');
	const [isUploading, setIsUploading] = useState(false);
	const textLength = text.length;
	async function handleSubmit(event) {
		event.preventDefault();
		if (
			text &&
			author &&
			isValidHttpUrl(source) &&
			category &&
			textLength <= 200
		) {
			setIsUploading(true);
			const { data: newQuote, error } = await supabase
				.from('quotes')
				.insert([{ text, author, source, category }])
				.select();
			setIsUploading(false);
			if (!error) setQuotes((quotes) => [newQuote[0], ...quotes]);
			setText('');
			setAuthor('');
			setSource('');
			setCategory('');
			setShowForm(false);
		}
	}
	return (
		<form
			className='form'
			onSubmit={handleSubmit}>
			<input
				type='text'
				placeholder='Type your favourite quote here'
				onChange={(event) => setText(event.target.value)}
			/>
			<input
				type='text'
				placeholder='Author'
				onChange={(event) => setAuthor(event.target.value)}
				disabled={isUploading}
			/>
			<input
				type='text'
				placeholder='Source'
				onChange={(event) => setSource(event.target.value)}
				disabled={isUploading}
			/>
			<select
				value={category}
				onChange={(event) => setCategory(event.target.value)}
				disabled={isUploading}>
				<option value=''>Choose a category</option>
				{categories.map((category) => (
					<option value={category.name}>{category.name.toUpperCase()}</option>
				))}
			</select>
			<button
				className='btn form-btn'
				disabled={isUploading}>
				Done
			</button>
		</form>
	);
}
export default Form;
